import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { completeGoogleLogin } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams((location.hash || "").replace(/^#/, "")).get("session_id");
    (async () => {
      try {
        const user = await completeGoogleLogin(sessionId);
        window.history.replaceState({}, "", "/");
        navigate(user.role === "supplier" ? "/portal" : user.role === "karyawan" ? "/transactions" : "/dashboard", { replace: true });
      } catch (e) {
        toast.error(formatApiError(e.response?.data?.detail) || "Login Google gagal");
        navigate("/login", { replace: true });
      }
    })();
  }, [completeGoogleLogin, location.hash, navigate]);

  return (
    <div className="min-h-screen grid place-items-center bg-background" data-testid="auth-callback">
      <div className="flex flex-col items-center gap-3">
        <div className="h-8 w-8 rounded-full border-2 border-primary border-t-transparent animate-spin" />
        <p className="text-sm text-muted-foreground">Memproses login Google...</p>
      </div>
    </div>
  );
}
